import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { Component, computed, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { DocumentItemPartial } from 'src/app/domain/entities/partials/documents/document-item.partial';
import { RaIconComponent } from 'src/app/shared/components/ra-icon/ra-icon.component';
import { RaSquareIconComponent } from 'src/app/shared/components/ra-square-icon/ra-square-icon.component';
import { RaEditTooltipDirective } from '../../../directives/ra-edit-tooltip/ra-edit-tooltip.directive';
import { EditDataService } from '../../../services/_edit-data.service';
import { EditItemsService } from '../../../services/edit-items.service';
import { EditService } from '../../../services/edit-service';

/**
 * Card de uma QUEBRA DE PÁGINA (PAGE_BREAK) na lista de itens da seção.
 *
 * Não passa pelo `card-base`: não há texto para editar, nem IA, nem favoritar,
 * e o card-base carrega tudo isso. O que ele reaproveita do card-base é só o
 * que faz sentido aqui, reescrito: seleção, alça de arraste e remover — nas
 * MESMAS posições dos demais cards (gutter e rail fora da folha).
 *
 * A seleção existe para a quebra acompanhar o bloco num "mover para outra
 * seção" — sem ela, mover um trecho do documento deixaria a quebra para trás
 * (é o comportamento do app, e os dois clientes precisam concordar).
 */
@Component({
    selector: 'page-break-card',
    templateUrl: 'page-break-card.component.html',
    styleUrl: 'page-break-card.component.scss',
    imports: [
        FormsModule,
        TranslatePipe,
        RaIconComponent,
        RaSquareIconComponent,
        RaEditTooltipDirective,
        CdkDragHandle,
    ],
})
export class PageBreakCardComponent {
    public field = input.required<DocumentItemPartial>();

    private _editDataService = inject(EditDataService);
    private _editItemsService = inject(EditItemsService);
    private _editService = inject(EditService);

    public disabled = computed(
        () =>
            this._editService.loading() ||
            this._editDataService.currentSessionIsDisabled() ||
            this._editDataService.documentIsBlocked()
    );

    /** Espelha o `selectItem` do card-base: marca o campo e sincroniza a lista. */
    public selectItem(event: Event): void {
        event.stopPropagation();

        const field = this.field();
        const target = event.target as HTMLInputElement | null;
        const isSelected = target?.checked ?? !field.selected;
        field.selected = isSelected;

        if (field.selected) {
            this._editDataService.addSelectedItem(field);
        } else {
            this._editDataService.removeSelectedItem(field);
        }
    }

    public remove(): void {
        this._editItemsService.removeItem([this.field()._id]);
    }
}
